import Button from "../components/common/Button"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { userActions } from "../store/user"
import { filterActions } from "../store/filter"
import classes from './Logout.module.css'

export default function Logout() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const logoutHandler = () => {
        dispatch(userActions.setToken(null))
        dispatch(userActions.setUser(null))
        dispatch(filterActions.resetSavedViews())
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('userLocations')
        localStorage.clear()
        navigate('/')
    }
    return <Button to='/' className={classes.logout} click={logoutHandler} btnStyle={'btn_simple'} title={'logout'} bypassisCaseArchived={true}>
        <i className="ti ti-logout"></i>
    </Button>
}